import { Helmet } from 'react-helmet-async';
import { faker } from '@faker-js/faker';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container } from '@mui/material';
// sections
import { AppOrderTimeline, AppCurrentVisits, AppWebsiteVisits, AppWidgetSummary } from '../sections/@dashboard/app';

// ----------------------------------------------------------------------

export default function SalesDashboard() {
    const theme = useTheme();
    return (
        <>
            <Helmet>
                <title> Dashboard </title>
            </Helmet>

            <Container maxWidth="xl">
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={3}>
                        <AppWidgetSummary title="Total Sales" total={714000} icon={'carbon:sales-ops'} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <AppWidgetSummary title="Active Leads" total={1352831} color="info" icon={'guidance:auditorium'} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <AppWidgetSummary
                            title="Ongoing Deals"
                            total={1723315}
                            color="warning"
                            icon={'fluent-mdl2:review-response-solid'}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <AppWidgetSummary title="Closed Deals" total={234} color="error" icon={'mdi:planet-plus'} />
                    </Grid>

                    <Grid item xs={12} md={12} lg={12}>
                        <AppWebsiteVisits
                            title="Project Tracker"
                            subheader="(+43%) than last year"
                            chartLabels={[
                                '01/01/2003',
                                '02/01/2003',
                                '03/01/2003',
                                '04/01/2003',
                                '05/01/2003',
                                '06/01/2003',
                                '07/01/2003',
                                '08/01/2003',
                                '09/01/2003',
                                '10/01/2003',
                                '11/01/2003',
                            ]}
                            chartData={[
                                {
                                    name: 'Sales',
                                    type: 'column',
                                    fill: 'solid',
                                    data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
                                },
                                {
                                    name: 'Leads',
                                    type: 'area',
                                    fill: 'gradient',
                                    data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
                                },
                                {
                                    name: 'Ongoing Deals',
                                    type: 'line',
                                    fill: 'solid',
                                    data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
                                },
                                {
                                    name: 'Closed Deals',
                                    type: 'column',
                                    fill: 'solid',
                                    data: [14, 25, 36, 30, 45, 35, 63, 52, 59, 36, 39],
                                },
                            ]}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={6}>
                        <AppCurrentVisits
                            title="Project Reports"
                            chartData={[
                                { label: 'Pending', value: 4344 },
                                { label: 'Inprogress', value: 5435 },
                                { label: 'Completed', value: 1443 },
                                { label: 'Waiting', value: 4443 },
                            ]}
                            chartColors={[
                                theme.palette.primary.main,
                                theme.palette.info.main,
                                theme.palette.warning.main,
                                theme.palette.error.main,
                            ]}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={6}>
                        <AppOrderTimeline
                            title="Projects Timeline"
                            list={[...Array(5)].map((_, index) => ({
                                id: faker.datatype.uuid(),
                                title: [
                                    'Monthly sales target achieved',
                                    'New client deal closed',
                                    'Quarterly revenue milestone reached',
                                    'Biggest order of the month secured',
                                    'Sales team exceeded expectations'
                                ][index],
                                type: `order${index + 1}`,
                                time: faker.date.past(),
                            }))}
                        />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}